import React, { useEffect, useState } from 'react';
import { Modal, Button, Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PageList, FormLayout } from '../../components/PageComponents';
import { usePageAPI } from '../../hooks/usePageAPI';
import Head from '../layouts/Head';
import LoadingDashboardContent from '../../components/LoadingDashboardContent';
import CartModal from '../../components/Modal/CartModal';

const AdminCart = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { fetchPages, fetchPage, createPage, updatePage, deletePage } = usePageAPI();
  const [pageData, setPageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [searchBy, setSearchBy] = useState('title');
  const [searchValue, setSearchValue] = useState('');
  const [isReload, setIsReload] = useState(false);

  const pageType = {
    isNew: pathname.includes('new'),
    isEdit: pathname.includes('edit'),
    isList: !(pathname.includes('new') || pathname.includes('edit')), 
  };

  useEffect(() => {
    const params = new URLSearchParams(search);
    const page = Number(params.get('page')) || 1;
    const limit = Number(params.get('limit')) || 20;
    const searchBy = params.get('searchBy') || 'title';
    const searchValue = params.get('searchValue') || '';

    setCurrentPage(page);
    setLimit(limit);
    setSearchBy(searchBy);
    setSearchValue(searchValue);

    if (pageType.isList) {
      fetchPages({
        type: 'cart/admin',
        limit: limit,
        currentPage: page,
        searchBy: searchBy,
        searchValue: searchValue,
        setLoading: setLoading,
        setProgress: setProgress
      }).then(({ data, dataCount }) => {
        setPageData({
          data,
          dataCount,
        });
      });
    }
    
    if (isReload) {
      setIsReload(false);
    }
  }, [pathname, search, isReload]);

  const updateUrlParams = (page, limit, searchBy, searchValue) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    params.set('searchBy', searchBy);
    params.set('searchValue', searchValue);
    navigate({ pathname: '/admin/page/list', search: params.toString() });
  };

  return (
    <>
      <Head title={getPageTitle(pageType)} />

      {pageType.isList && (
        loading ? <LoadingDashboardContent progress={progress} /> :
          <PageList
            itemType={'cart'}
            itemId={'id'}
            pageTitle={'Cart List'}
            pageData={pageData.data}
            actionApplyKeyMap={{
              'Delete': 'delete',
            }}
            columns={[ 'Cart', 'Customer', 'Device', 'Total', 'Items']}
            filterBy={false}
            columnKeyMap={{
              'Cart': (item) => <CartModal data={item.cart} />,
              'Customer': (item) => item.cart.userType,
              'Device': (item) => item.cart.userId,
              'Total': (item) => item.cart.totals.grandTotal,
              'Items': (item) => item.cart.items.reduce((sum, currentItem) => sum + currentItem.quantity, 0),
              'Created at': (item) => item.cart.createdAt,
              'Link': (item) => item.desc ? <a href={`/page/${item.id}`}>Go to page</a> : 'No link available',
            }}
            onAddNew={false}
            onView={false}
            onEdit={false}
            onDelete={false}
            totalRows={pageData.dataCount}
            updateUrlParams={updateUrlParams}
            isReload={setIsReload}
          />
      )}
    </>
  );
};

const getPageTitle = ({ isEdit, isNew }) =>
  isEdit ? "Edit Cart" : isNew ? "Create New Cart" : "Cart List";
export default AdminCart;
